export default __webpack_public_path__ + "9d93962e2867853d4f0dab777bc43a6d.woff2";